import { render, staticRenderFns } from "./EnergyEfficiencyChart.vue?vue&type=template&id=1d3faf67&scoped=true"
import script from "./EnergyEfficiencyChart.vue?vue&type=script&lang=js"
export * from "./EnergyEfficiencyChart.vue?vue&type=script&lang=js"
import style0 from "./EnergyEfficiencyChart.vue?vue&type=style&index=0&id=1d3faf67&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d3faf67",
  null
  
)

export default component.exports